import config from 'config';
import { flattenSubscriptions } from 'utils/subscriptionUtils';

const LOAD = 'horse-racing/my-stable-results/LOAD';
const LOAD_SUCCESS = 'horse-racing/my-stable-results/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/my-stable-results/LOAD_FAIL';

const initialState = {
  results: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        results: transformResult(action.result)
      };
    case LOAD_FAIL:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}

export function loadResults(subscriptions) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.post(config.api.horseRacing.loadResults, {
      data: {
        subscription: flattenSubscriptions(subscriptions, ['HORSE', 'JOCKEY', 'TRAINER'])
      }
    })
  };
}

export function transformResult({horse, jockey, trainer}){
  let resultsByDate = {};

  horse.forEach(h => {
    if (resultsByDate[h.race.race_summary.date] == undefined) {
      resultsByDate[h.race.race_summary.date] = [];
    }
    resultsByDate[h.race.race_summary.date].push({...h, matchType: "H"})
  });

  jockey.forEach(j => {
    if (resultsByDate[j.race.race_summary.date] == undefined) {
      resultsByDate[j.race.race_summary.date] = [];
    }
    resultsByDate[j.race.race_summary.date].push({...j, matchType: "J"});
  });
  trainer.forEach(t => {
    if (resultsByDate[t.race.race_summary.date] == undefined) {
      resultsByDate[t.race.race_summary.date] = [];
    }
    resultsByDate[t.race.race_summary.date].push({...t, matchType: "T"});
  });

  return resultsByDate;
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/myStableResults.js